import { formatMarkdown } from '../lib/format-markdown';
import { formatMessageTime } from '../lib/format-message-time';
import { BotAvatar } from './bot-avatar';

import styles from './chat-message.module.css';

export function ChatMessage({ message }) {
	const isUser = message.type === 'user';

	return (
		<div
			className={`${styles.message} ${
				isUser ? styles.userMessage : styles.assistantMessage
			}`}
		>
			{!isUser && <BotAvatar />}
			<div className={styles.messageContent}>
				<div className={styles.messageText}>
					{isUser ? message.text : formatMarkdown(message.text)}
				</div>
				<div className={styles.messageTime}>
					{formatMessageTime(message.timestamp)}
				</div>
			</div>
		</div>
	);
}
